<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >MONTHS</label>
  <br />
  <select
    :id="htmlId"
    class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey"
    :value="rangeMonths"
    @change="handleRangeMonthsMenuChanged($event)"
  >
    <option
      v-for="rangeMonthsOption in RANGE_MONTHS_OPTIONS_ARRAY"
      :key="rangeMonthsOption"
      :value="rangeMonthsOption"
    >{{ rangeMonthsOption }}</option>
  </select>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { RANGE_MONTHS_OPTIONS_ARRAY } from '@/enums/range-months-options';

  const props = defineProps<{
    rangeMonths: string;
    htmlId: string;
  }>();
  const { rangeMonths, htmlId } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:rangeMonths', rangeMonths: string): void;
  }>();

  function handleRangeMonthsMenuChanged(e: Event) {
    if (!(e.target instanceof HTMLSelectElement)) {
      return;
    }

    emit('update:rangeMonths', e.target.value);
  }
</script>
